import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/app/Layout";
import { Input } from "@/components/ui/input";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { api } from "@/lib/api";
import { Search } from "lucide-react";

export default function Creators() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [profession, setProfession] = useState("");

  const load = async () => {
    const { data } = await api.get("/users", { params: { q: q || undefined, profession: profession || undefined, limit: 48 } });
    setUsers(data);
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <Layout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="meta-label mb-2">The community</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">Creators</h1>

        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="mt-8 flex flex-col sm:flex-row gap-3">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search creators…" className="pl-9" data-testid="creators-search" />
          </div>
          <Input value={profession} onChange={(e) => setProfession(e.target.value)} placeholder="Filter by profession…" className="sm:w-64" data-testid="creators-profession-filter" />
          <button className="px-5 py-2 rounded-md bg-foreground text-background text-sm font-medium" data-testid="creators-search-btn">Search</button>
        </form>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {users.map((u) => (
            <Link key={u.user_id} to={`/u/${u.username}`} className="group block rounded-lg overflow-hidden border border-border/60 bg-card card-hover" data-testid={`creator-${u.username}`}>
              <div className="h-28 bg-muted overflow-hidden">
                {u.banner_url && <img src={u.banner_url} alt="" className="w-full h-full object-cover image-zoom" />}
              </div>
              <div className="p-5 -mt-10 relative">
                <Avatar className="h-16 w-16 ring-4 ring-card"><AvatarImage src={u.avatar_url} /><AvatarFallback>{u.full_name?.[0]}</AvatarFallback></Avatar>
                <div className="mt-3 font-display font-semibold">{u.full_name}</div>
                <div className="text-xs text-muted-foreground">@{u.username}</div>
                <div className="mt-2 text-sm text-muted-foreground line-clamp-2 min-h-[2.5rem]">{u.profession}</div>
                <div className="mt-3 flex gap-4 meta-label">
                  <span>{u.projects_count || 0} works</span>
                  <span>{u.followers_count || 0} followers</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        {users.length === 0 && <div className="text-center py-20 text-muted-foreground">No creators found.</div>}
      </section>
    </Layout>
  );
}
